import React from 'react';
import { useTheme, createUseStyles } from 'react-jss';
import PropTypes from 'prop-types';
import Icon from '@mdi/react';
import { mdiHexagonOutline } from '@mdi/js';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import Container from '@components/Container';

const useStyles = createUseStyles(({
  rem,
}) => ({
  '@global': {
    '@keyframes load': {
      '0%': {
        transform: 'rotate(0deg)'
      },
      '100%': {
        transform: 'rotate(360deg)'
      }
    },
  },
  animation: {
    height: 'auto',
    marginBottom: rem(10),
    animation: 'load 3s infinite linear',
  },
}), {
  name: 'Loading'
})

const Loading = (props) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { size, className: classNameProp } = props;
  const { t } = useTranslation();

  return (
    <Container 
      flex
      alignItems='center'
      direction='column'
      className={classNameProp}
    >
       <Icon
        size={size}
        path={mdiHexagonOutline}
        className={classNames(classes.animation)}
      />
      <span>{t('loading')}……</span>
    </Container>
  )
};

Loading.propTypes = {
  size: PropTypes.number.isRequired,
  className: PropTypes.string,
}

export default Loading;
